export const SESSION_FLAGS = {
  HAS_PASSED_ORGANISER: "hasPassedOrganiserPage",
} as const;

export const setOrganiserPassedFlag = (): void => {
  if (typeof window !== "undefined") {
    sessionStorage.setItem(SESSION_FLAGS.HAS_PASSED_ORGANISER, "true");
  }
};

export const removeOrganiserPassedFlag = (): void => {
  if (typeof window !== "undefined") {
    sessionStorage.removeItem(SESSION_FLAGS.HAS_PASSED_ORGANISER);
  }
};

export const hasPassedOrganiser = (): boolean => {
  if (typeof window !== "undefined") {
    return (
      sessionStorage.getItem(SESSION_FLAGS.HAS_PASSED_ORGANISER) === "true"
    );
  }
  return false;
};
